import { useSearchParams, useNavigate } from 'react-router-dom'; // Importamos useNavigate
import MainLayout from '../../layouts/MainLayout/MainLayout';
import { Button, Stack, Text } from '@mantine/core'; // Añadí Text para el contador
import showNotification from '../../utils/showNotification';
import axios from 'axios';
import { useState, useEffect } from 'react';

export default function CancelSubscription() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const email = searchParams.get("email");
    const subscription_id = searchParams.get("subscription_id");

    const [isLoading, setIsLoading] = useState(false);
    const [countdown, setCountdown] = useState(null);

    useEffect(() => {
        if (countdown === null) return;

        if (countdown === 0) {
            navigate("/");
            return;
        }

        const timer = setTimeout(() => {
            setCountdown(countdown - 1);
        }, 1000);

        return () => clearTimeout(timer);
    }, [countdown, navigate]);

    const onSubmit = async (event) => {
        event.preventDefault();

        if (!email || !subscription_id) {
            return showNotification({
                title: "Ha ocurrido un error",
                message: "Por favor, contactate con soporte web"
            });
        }

        const jsonData = {
            user_email: email,
            subscription_id
        };

        setIsLoading(true);

        const URL = `${process.env.REACT_APP_BACKEND_SERVER}/payment/subscription/cancel`;

        try {
            await axios.put(URL, jsonData);

            showNotification({
                title: 'Operación exitosa',
                message: "Ya has sido desvinculado del plan. Vamos a redirigirte al inicio.",
                color: "green",
                status: "success",
                autoClose: 5000
            });


            setCountdown(5);

        } catch (error) {
            console.log(error);
            showNotification({
                color: "red",
                status: "error",
                title: "Ha ocurrido un error.",
                message: `Detalle: ${error?.message || "Contactate con soporte"}`,
                autoClose: 12000
            });
            setIsLoading(false);
        }
    };

    return (
        <>
            <MainLayout>
                <div className="SubscriptionPage-main-container">
                    <h1 className="landingHero__title">
                        Comunidad <br />
                        <span className="landingHero__gradient">
                            Forvet
                        </span>
                    </h1>

                    <form onSubmit={onSubmit}>
                        <Stack mb={20} w='100%' align='center'>
                            <p className='SubscriptionPage--description'>
                                ¿Estás seguro de querer irte? <br />
                                Te vamos a extrañar
                            </p>

                            {countdown === null ? (
                                <>
                                    <p className='SubscriptionPage--description'>
                                        Para terminar la acción debes confirmar tu desviniculación del plan.
                                    </p>
                                    <Button
                                        loading={isLoading}
                                        disabled={isLoading}
                                        type='submit'
                                        color='var(--color-tertiary)'
                                    >
                                        Desvincularme
                                    </Button>
                                </>
                            ) : (
                                <p className='SubscriptionPage--description'>
                                    Redirigiendo al inicio en {countdown} segundos...
                                </p>
                            )}
                        </Stack>
                    </form>
                </div>
            </MainLayout>
        </>
    );
}